import { download, openFile } from '@/services/file.service.js'
import { getBlobFromCanvas } from '@/services/canvas.service.js'

export const Attachments = api => ({
  save(files) {
    const formData = new FormData()
    for (const file of files) {
      formData.append('attachments[]', file)
    }
    return api.post('/v1/attachments', formData)
  },
  get() {
    return api.get('/v1/attachments')
  },
  async storeImage(image, resizeWidth) {
    const formData = new FormData()
    const blob = await getBlobFromCanvas(image)
    formData.append('image', blob)
    formData.append('width', resizeWidth)
    return await api.post('/v1/attachments/image', formData)
  },
  async download(slug, name) {
    const { data } = await api({
      url: `/v1/attachments/${slug}`,
      method: 'GET',
      responseType: 'blob'
    })
    download(data, name)
  },


  async downloadS3File(path, name) {
    const { data } = await api({
      url: path,
      method: 'GET',
      responseType: 'blob'
    })
    download(data, name)
  },

  async open(slug, name, openInNewTab = true) {
    const { data } = await api({
      url: `/v1/attachments/${slug}`,
      method: 'GET',
      responseType: 'blob'
    })
    openFile(data, openInNewTab)
    return data
  },

  async openPublic(process, vacancy, profile, attachment, time, name, openInNewTab = true) {
    const { data } = await api({
      url: `/v1/processes/${process}/${vacancy}/${profile}/public/attachments/${attachment}/${time}`,
      method: 'GET',
      responseType: 'blob'
    })
    openFile(data, openInNewTab)
    return data
  },

  async openS3File(path, name) {
    const { data } = await api({
      url: path,
      method: 'GET',
      responseType: 'blob'
    })
    openFile(data)
    return data
  }
})
